import request from './axios'

/**
 * 生成推荐链接
 * @returns {Promise} 推荐链接信息
 */
export const generateReferralLink = () => {
  return request({
    url: '/api/v1/referral/generate',
    method: 'get'
  })
}

/**
 * 验证推荐链接
 * @param {string} encryptedReferrerId 加密的推荐人ID
 * @returns {Promise} 验证结果
 */
export const validateReferral = (encryptedReferrerId) => {
  return request({
    url: '/api/v1/referral/validate',
    method: 'post',
    data: {
      encrypted_referrer_id: encryptedReferrerId
    }
  })
}

/**
 * 获取推荐统计
 * @returns {Promise} 推荐统计数据
 */
export const getReferralStats = () => {
  return request({
    url: '/api/v1/referral/stats',
    method: 'get'
  })
}

/**
 * 获取推荐列表
 * @param {Object} params 查询参数
 * @param {string} params.type 推荐类型 (direct/indirect)
 * @param {number} params.page 页码
 * @param {number} params.page_size 每页大小
 * @returns {Promise} 推荐列表
 */
export const getReferrals = (params) => {
  return request({
    url: '/api/v1/referral/list',
    method: 'get',
    params
  })
}

/**
 * 获取推荐二维码
 * @param {string} data 二维码数据
 * @returns {string} 二维码URL
 */
export const getQRCodeUrl = (data) => {
  return `/api/referral/qrcode?data=${encodeURIComponent(data)}`
}